import { createAction } from '@reduxjs/toolkit';

const changeLocale = createAction('localesAction/changeLocale');
export default changeLocale;
